<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Tags />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Tags from "../../components/GestionEmpleados/Views/Employee/Tags.vue";
export default {
  components: { LandingToolbar, Tags },
};
</script>
